module.exports = __webpack_public_path__ + "static/media/eleanorLives.0947735f.png";